import axios from 'axios';
import { API_BASE_URL } from '../config';

export interface Position {
  id: number;
  coin: string;
  side: 'long' | 'short';
  size: number;
  entry_price: number;
  current_price: number;
  unrealized_pnl: number;
  leverage: number;
  margin: number;
  liquidation_price: number;
  opened_at: string;
  last_updated: string;
}

export interface PositionMetrics extends Position {
  roe_percent: number;
  distance_to_liquidation_percent: number;
}

class PositionService {
  private baseUrl: string;

  constructor() {
    this.baseUrl = `${API_BASE_URL}/position`;
  }

  async getPositions(): Promise<Position[]> {
    try {
      const response = await axios.get<Position[]>(this.baseUrl);
      return response.data;
    } catch (error) {
      console.error('Error fetching positions:', error);
      throw error;
    }
  }

  async getPositionMetrics(coin: string): Promise<PositionMetrics> {
    try {
      const response = await axios.get<PositionMetrics>(`${this.baseUrl}/${coin}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching metrics for ${coin}:`, error);
      throw error;
    }
  }
}

export const positionService = new PositionService(); 